/**
 * SAPI Color Palette - Standard colors used across all pages
 */
export const COLORS = {
  void: "#06030E",
  navy: "#0F0830",
  midnight: "#1A1540",
  gold: "#C9963A",
  paleGold: "#EDD98A",
  parchment: "#FBF5E6",
  muted: "#9880B0",
  emerald: "#28A868",
  amber: "#F0C050",
  crimson: "#C03058",
  bronze: "rgba(107,69,8,0.22)",
  blue: "#4A7AE0",
};

/**
 * Common layout constants
 */
export const LAYOUT = {
  maxWidth: 1100,
  padding: "32px",
  borderColor: "rgba(107,69,8,0.22)",
};

/**
 * Common typography styles
 */
export const TYPOGRAPHY = {
  serif: "'Georgia', 'Times New Roman', serif",
  sans: "system-ui, sans-serif",
};

const constants = { COLORS, LAYOUT, TYPOGRAPHY };
export default constants;
